/* tslint:disable */
/* eslint-disable */
/**
 * SlashID API v1.1
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface PostDirectId201ResponseAllOf
 */
export interface PostDirectId201ResponseAllOf {
    /**
     * 
     * @type {string}
     * @memberof PostDirectId201ResponseAllOf
     */
    result?: string;
}

/**
 * Check if a given object implements the PostDirectId201ResponseAllOf interface.
 */
export function instanceOfPostDirectId201ResponseAllOf(value: object): boolean {
    let isInstance = true;

    return isInstance;
}

export function PostDirectId201ResponseAllOfFromJSON(json: any): PostDirectId201ResponseAllOf {
    return PostDirectId201ResponseAllOfFromJSONTyped(json, false);
}

export function PostDirectId201ResponseAllOfFromJSONTyped(json: any, ignoreDiscriminator: boolean): PostDirectId201ResponseAllOf {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'result': !exists(json, 'result') ? undefined : json['result'],
    };
}

export function PostDirectId201ResponseAllOfToJSON(value?: PostDirectId201ResponseAllOf | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'result': value.result,
    };
}

